import * as React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {Autocomplete, Box,Card,CardMedia,Container,Typography,} from "@mui/material";
import { ButtonBrand, TypographyBrand } from '../../../getLPTheme';
import { Link as RouterLink } from 'react-router-dom';
import Copyright from '../../../auxiliares/Copyright';


export default function VideoTierra () {

  return (
    <Box id="videoTierra" sx={{mt: {xs: 2, md: 2},}}>
      <Box sx={{display: {xs: 'none', sm: 'grid', md: 'grid', lg: 'grid', xl: 'grid'}}}>
        <Box sx={{display: 'grid', position: 'relative', width: '100%' }}>
          <CardMedia
            component='video'
            src={"https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/banner_pelota.mp4"}
            autoPlay
            loop
            muted
            sx={{
              p: 2,
              height: 800,
              maxWidth: "80%",   // ocupa solo 80% del ancho
              margin: "0 auto", // centra el video
              borderRadius: 2,  // opcional, esquinas redondeadas
              objectFit: "cover"
            }}
          >
          </CardMedia>
          <Box sx={{
            position: 'absolute',
            left: 0,
            height: 800,
            width: '100%',
            bgcolor: 'rgba(0, 0, 0, 0.20)',
            color: 'white',
            direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"
            }}
          >
            <TypographyBrand sx={{ fontSize: {xl: "4vw", lg: "2.5vw", md: "2.5vw", sm:"2.5vw", xs:"2.5vw"} }}>
            ¡ HACETE MIEMBRO DE WGC <br/> Y COMENZÁ A DISFRUTAR !
            </TypographyBrand>
          </Box>
        </Box>

        <Box sx={{mt:1}}>
          <RouterLink to={"/registrarse"} style={{ textDecoration: 'none' }}>
            <ButtonBrand sx={{width: 250}}>
              QUIERO SER SOCIO
            </ButtonBrand>
          </RouterLink>
        </Box>
        <Box sx={{direction:"row", justifyContent:"center", alignItems:"center", display: "flex"}}>
          <Box sx={{mt:4, mb:2, width: '80%'}}>
            <TypographyBrand sx={{fontSize: {xl: "1.5vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
              UNA VEZ DADO DE ALTA COMO SOCIO EN NUESTRA PLATAFORMA TENDRAS TU USUARIO Y CONTRASEÑA PARA COMENZAR A APROVECHAR TODOS LOS BENEFICIOS DEL CLUB DE GOLF MAS GRANDE DEL MUNDO
            </TypographyBrand>
          </Box>
        </Box>
      </Box>
      {/* Pantalla chica */}

      <Box sx={{display: {xs: 'grid', sm: 'none', md: 'none', lg: 'none', xl: 'none'}}}>
        <Box sx={{display: 'grid', position: 'relative', width: '100%' }}>
          <CardMedia
            component='video'
            src={"https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/banner_pelota.mp4"}
            autoPlay
            loop
            muted
            sx={{
              p: 2,
              height: 800,
              maxWidth: {xl: "80%", lg: "80%", md: "85%", sm: "90%", xs: "95%"}, 
              margin: "0 auto", 
              borderRadius: 2, 
              objectFit: "cover"
            }}
          >
          </CardMedia>
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: 600,
            width: '100%',
            bgcolor: 'rgba(0, 0, 0, 0.20)',
            color: 'white',
            direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"
            }}
          >
            <TypographyBrand sx={{ fontSize: {xl: "4vw", lg: "2.5vw", md: "2.5vw", sm:"2.5vw", xs:"6vw"} }}>
            ¡ HACETE MIEMBRO DE WGC <br/> Y COMENZÁ A DISFRUTAR !
            </TypographyBrand>
          </Box>
        </Box>

        <Box sx={{mt:1}}>
          <RouterLink to={"/registrarse"} style={{ textDecoration: 'none' }}>
            <ButtonBrand sx={{width: 250}}>
              QUIERO SER SOCIO
            </ButtonBrand>
          </RouterLink>
        </Box>
        <Box sx={{direction:"row", justifyContent:"center", alignItems:"center", display: "flex"}}>
          <Box sx={{mt:2, mb:2, width: '80%'}}>
            <TypographyBrand sx={{fontSize: {xl: "1.5vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
              UNA VEZ DADO DE ALTA COMO SOCIO EN NUESTRA PLATAFORMA TENDRAS TU USUARIO Y CONTRASEÑA PARA COMENZAR A APROVECHAR TODOS LOS BENEFICIOS DEL CLUB DE GOLF MAS GRANDE DEL MUNDO
            </TypographyBrand>
          </Box>
        </Box>
      </Box>


      <Copyright />
    </Box>
  );
};
